module.exports = __webpack_public_path__ + "img/Pictorial.73218006.svg";